export default __webpack_public_path__ + "static/media/ic_engine.19f51c71.svg";